// extracted by mini-css-extract-plugin
module.exports = {"container":"extra_container__cM6J_","tagContainer":"extra_tagContainer__2iMdn","popularTags":"extra_popularTags__3lxCZ"};